module.exports = __webpack_public_path__ + "static/media/equipe-tindog3.82a69363.png";